import * as Yup from "yup";
import { alphaMessage } from "./messages";

export default function () {
    return Yup.string()
        .transform((value) => { return value ? String(value).trim() : value })
        .test('alpha', alphaMessage, (val) => {
            return !(/[<>@!#$%^&*()_+=?\\\/"|~{}\[\]]|[0-9]/gsu.test(val))
        })
}
